import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import OrchestratorService from "../services/orchestrator.service";


import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};


//const users = {data: list, loading: false};


export const createOrchestrator = createAsyncThunk(
  "orchestrator/create",
  async (orchestrator, thunkAPI) => {
    try {
      const data = await OrchestratorService.createOrchestrator(orchestrator);
      thunkAPI.dispatch(setMessage({message: "Orchestrator created successfully", type: "success"}));
      return { orchestrator: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateOrchestrator = createAsyncThunk(
  "orchestrator/update",
  async ( {org},thunkAPI) => {
    try {
      const data = await OrchestratorService.updateOrchestrator(org);
      thunkAPI.dispatch(setMessage({message: "Orchestrator updated successfully", type: "success"}));
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteOrchestrator = createAsyncThunk(
  "orchestrator/delete",
  async ({ id }, thunkAPI) => {
    try {
      const data = await OrchestratorService.deleteOrchestrator(id);
      thunkAPI.dispatch(setMessage({message: "Orchestrator deleted successfully", type: "success"}));
      return { orchestrator: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const getOrchestrators = createAsyncThunk(
  "orchestrator/get_list",
  async ({search}, thunkAPI) => {
    try {

      const data = await OrchestratorService.getOrchestrators(search);
      return { orchestrators: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getOrchestrator = createAsyncThunk(
  "orchestrator/get",
  async ({id}, thunkAPI) => {
    try {
      const data = await OrchestratorService.getOrchestrator(id);
      return { orchestrator: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getThisOrchestrator = createAsyncThunk(
  "orchestratorThis/get",
  async (thunkAPI) => {
    try {
      const data = await OrchestratorService.getThisOrchestrator();
      return { orchestrator: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {data: list, loading: false, thisOrchestrator: {} }

const organizationSlice = createSlice({
  name: "orchestrators",
  initialState,
  extraReducers: {

    [createOrchestrator.pending]: (state, action) => {
      state.loading = true;
    },
    [createOrchestrator.fulfilled]: (state, action) => {
      const newOrchestrator = action.payload.orchestrator;
      state.data.list.push(newOrchestrator);
      state.data.total += 1;
      state.loading = false;
    },
    [createOrchestrator.rejected]: (state, action) => {
      state.loading = false;
    },

    [deleteOrchestrator.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteOrchestrator.fulfilled]: (state, action) => {
      // Backend returns {success: true, id: "..."}
      const deletedId = action.payload.orchestrator.id;
      const updatedList = state.data.list.filter((orchestrator) => orchestrator.id !== deletedId);
      state.data.list = updatedList;
      state.data.total -= 1;
      state.loading = false;
    },
    [deleteOrchestrator.rejected]: (state, action) => {
      state.loading = false;
    },

    [getOrchestrators.pending]: (state, action) => {
      state.loading = true;
    },
    [getOrchestrators.fulfilled]: (state, action) => {
      state.data = action.payload.orchestrators;
      state.loading = false;
    },
    [getOrchestrators.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },

    [updateOrchestrator.fulfilled]: (state, action) => {

      let organizations = state.data.list;
      let thisOrg = organizations.find((org) => org.id === action.payload.data.id)

      thisOrg.name = action.payload.data.name
      thisOrg.domain = action.payload.data.domain
      thisOrg.active = action.payload.data.active

    },

    [getOrchestrator.pending]: (state, action) => {
      state.loading = true;
    },
    [getOrchestrator.fulfilled]: (state, action) => {

     
      const newPayload = action.payload.orchestrator;

      const existingIndex = state.data.list.findIndex(
        payload => payload.id === newPayload.id
      );
    
      if (existingIndex >= 0) {
        // The payload already exists, replace it
        state.data[existingIndex] = newPayload;
      } else {
        // The payload doesn't exist, add it
        state.data.list.push(newPayload);
      }
      state.loading = false;

    },
    [getOrchestrator.rejected]: (state, action) => {
      state.loading = false;
    },

    [getThisOrchestrator.pending]: (state, action) => {
      state.loading = true;
    },
    [getThisOrchestrator.fulfilled]: (state, action) => {


      const newPayload = action.payload.orchestrator;

      state.thisOrchestrator = newPayload;
      state.loading = false;

    },
    [getThisOrchestrator.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});


const { reducer } = organizationSlice;
export default reducer;